import { HOME_IMG } from "../lib/brand";
import { InstallButton } from "./InstallPrompt";

export default function AuthLayout({ children }) {
  return (
    <div className="relative min-h-screen w-full flex items-center justify-center px-5 py-6 overflow-hidden bg-[#0a0a0a]">
      {/* Homeownership backdrop */}
      <img
        src={HOME_IMG}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover"
        draggable="false"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/78 via-black/86 to-black/95" />
      <div className="absolute inset-0 bg-[#0a0a0a]/30" />
      <div className="mpl-grain absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-md flex flex-col items-center">
        <div className="mpl-rise w-full max-w-[370px] mb-3">
          <img
            src="/brand/logo-wide.png"
            alt="My Pocket Lender — Powered by LolliPop"
            className="w-full h-auto block select-none drop-shadow-[0_10px_40px_rgba(255,59,48,0.35)]"
            draggable="false"
          />
        </div>
        <div className="w-full mpl-rise" style={{ animationDelay: "90ms" }}>
          {children}
          <InstallButton variant="auth" />
        </div>
      </div>
    </div>
  );
}
